(function ($) {

    //'use strict';
    var win = $(window);
    var saveForm;
    var savePopup;

    var udpateDefaultSaveName = function () {
        var region = $(".admin-form-inner [name=field11]").val();
        var agglo = $(".admin-form-inner [name=field12]").val();
        var city = $(".admin-form-inner [name=field13]").val();
        var nameArr = [];

        if (region && region !== "all") {
            nameArr.push(region);
        }
        if (agglo && agglo !== "all") {
            nameArr.push(agglo);
        }
        if (city && city !== "all") {
            nameArr.push(city);
        }

        savePopup.find("input[name='saveName']")
            .val(!nameArr.length ? "" : nameArr.join("_"))
            .trigger("change");
    };

    var previewSaveName = function (e) {
        var val = friendlyUrlize($(e.currentTarget).val());
        var lang = $(".admin-form-inner [name=lang]").val();
        var filename;

        if (lang === "") {
            filename = val + "-fr.pdf, " + val + "-en.pdf";
        } else {
            filename = val + "-" + lang + ".pdf";
        }
        savePopup.find(".name-preview").text(filename);
    };

    var friendlyUrlize = function (str) {
        return removeDiacritics(str.toLocaleLowerCase().replace(/[ '_"]/g, "-"));
    };

    var processForm = function () {
        var lang = saveForm.find("[name=lang]").val();
        var chapterInputs = saveForm.find(".chapterHandlesInput:checked");
        var newChapterString = "";
        var subchapterInputs = saveForm.find(".subchapterHandlesInput:checked");
        var subchapterList = "";
        var legalStatusInputs = saveForm.find(".legalStatusInput:checked");
        var legalStatusList = "";
        var regionList = "";
        var agglomerationList = "";
        var cityList = "";

        if (!chapterInputs.length && $(".chapterHandlesInput.required").length) {
            saveForm.find(".admin-form-chapter-ctn").addClass("has-error");
            return false;
        }
        
        if (lang === "") {
            // Admin can have an option to select all languages by having the lang input empty
            lang = document.documentElement.lang;
        }

        chapterInputs.each(function () {
            if (newChapterString !== "") {
                newChapterString += ",";
            }
            newChapterString += $(this).val();
        });
        saveForm.find("[name='chapterHandles']").val(newChapterString);

        subchapterInputs.each(function () {
            if (subchapterList !== "") {
                subchapterList += ",";
            }
            subchapterList += this.getAttribute("data-" + lang);
        });
        saveForm.find("[name='subchapterHandles']").val(subchapterList);

        legalStatusInputs.each(function () {
            if (legalStatusList !== "") {
                legalStatusList += ",";
            }
            legalStatusList += this.value;
        });
        saveForm.find("[name='legalStatus']").val(legalStatusList);
        
        saveForm.find(".newrow .regionHandlesInput").each(function() {
            if (regionList !== "") {
                regionList += ", ";
            }
            regionList += this.value;
        });
        if (regionList === "") {
            regionList = "all";
        }
        saveForm.find("[name='field11']").val(regionList);
        
        saveForm.find(".newrow .agglomerationHandlesInput").each(function() {
            if (agglomerationList !== "") {
                agglomerationList += ", ";
            }
            agglomerationList += this.value;
        });
        if (agglomerationList === "") {
            agglomerationList = "all";
        }
        saveForm.find("[name='field12']").val(agglomerationList);

        saveForm.find(".newrow .cityHandlesInput").each(function() {
            if (cityList !== "") {
                cityList += ", ";
            }
            cityList += this.value;
        });
        if (cityList === "") {
            cityList = "all";
        }
        saveForm.find("[name='field13']").val(cityList);
        
        saveForm.addClass("processing");
    };

    var submitForm = function (e) {
        e.preventDefault();
        if (saveForm.hasClass("processing")) {
            return;
        }
        processForm();
        // Let's make sure the form is processed properly before submitting
        setTimeout(function () {
            saveForm.submit();
            if (saveForm.attr("target") === "_blank") {
                saveForm.removeClass("processing");
            }
        }, 450);
    };

    var saveDirectory = function () {
        var name = savePopup.find("input[name='saveName']").val();
        if (name !== "") {
            if (saveForm.hasClass("processing")) {
                return;
            }
            processForm(saveForm);
            // Let's make sure the form is processed properly before submitting
            setTimeout(function () {
                var params = $(".admin-form-inner").closest("form").serialize()
                    + "&name=" + name + "&addTrailingLang=true&save=true";
                $.post("/action/crgm", params, function (response) {
                    window.location.reload();
                });
            }, 450);
        } else {
            savePopup.find("input").addClass("error");
        }
    };

    var selectChapters = function (e) {
        var $it = $(e ? e.currentTarget || this : this);
        var $ctn = $it.closest(".custom-directory-chapter-item");
        var $subchapterInputs = $ctn.find(".subchapterHandlesInput");

        $subchapterInputs.prop("checked", $it.prop("checked"));
        saveForm.find(".custom-directory-chapter-ctn.has-error").removeClass("has-error");
    };

    var selectSubchapters = function (e) {
        var $it = $(e ? e.currentTarget || this : this);
        var $ctn = $it.closest(".custom-directory-chapter-item");
        var $chapterInput = $ctn.find(".chapterHandlesInput");
        var $subchapterInputs = $ctn.find(".subchapterHandlesInput");

        if ($it.prop("checked")) {
            $chapterInput.prop("checked", true);
            saveForm.find(".custom-directory-chapter-ctn.has-error").removeClass("has-error");
        } else if ($subchapterInputs.filter(":checked").length === 0) {
            $chapterInput.prop("checked", false);
        }
    };

    var selectAllLegalStatuses = function (e) {
        var $it = $(e ? e.currentTarget || this : this);
        var $ctn = $it.closest(".admin-form-status-ctn");
        var $inputs = $ctn.find(".legalStatusInput");

        $inputs.prop("checked", $it.prop("checked"));
    };

    var selectLegalStatus = function (e) {
        var $it = $(e ? e.currentTarget || this : this);
        var $ctn = $it.closest(".admin-form-status-ctn");
        var $inputs = $ctn.find(".legalStatusInput");
        var $inputAll = $ctn.find(".allLegalStatusInput");

        if (!$it.prop("checked")) {
            $inputAll.prop("checked", false);
        } else if ($inputs.filter(":checked").length === $inputs.length) {
            $inputAll.prop("checked", true);
        }
    };

    win.load(function () {
        saveForm = $(".custom-directory-form");
        savePopup = $(".popup-form-save");

        $(".admin-form-btn", saveForm).on("click", submitForm);
        $(".chapterHandlesInput", saveForm).on("change", selectChapters);
        $(".subchapterHandlesInput", saveForm).on("change", selectSubchapters);
        $(".allLegalStatusInput", saveForm).on("change", selectAllLegalStatuses);
        $(".legalStatusInput", saveForm).on("change", selectLegalStatus);

        $(".admin-save-form-btn").on("click", udpateDefaultSaveName);
        $("input[name='saveName']", savePopup).on("keypress change", previewSaveName);
        $(".custom-directory-save-btn").on("click", saveDirectory);
    });

})(jQuery);

